import { SeoEntries } from '@/lib/entities/seo/lib/seo-entries';

import { useTranslation } from 'next-i18next';

import styles from './BlogHubPage.module.scss';

type BlogUnavailablePageProps = {
  path: `/${string}`;
};

export const BlogUnavailablePage = ({ path }: BlogUnavailablePageProps) => {
  const {
    t,
    i18n: { language },
  } = useTranslation('index', { keyPrefix: 'blog' });
  const { t: tMeta } = useTranslation('index', { keyPrefix: 'meta' });

  return (
    <>
      <SeoEntries
        fallback={{
          title: tMeta('blog.title'),
          description: t('unavailableDescription'),
          openGraphImage: '/images/loyalty-program/og.webp',
        }}
        seo={null}
        language={language}
        path={path}
        robots="noindex, nofollow"
      />
      <main className={styles.hub}>
        <div className={styles.hub__container} role="status">
          <p className={styles.hub__empty}>{t('unavailableTitle')}</p>
          <p className={styles.hub__empty}>{t('unavailableDescription')}</p>
        </div>
      </main>
    </>
  );
};
